import { OrderConditionDetailsFormValues } from './orderConditionDetailsForm.schema';

export const SERVER_FREIGHT_FIELDS = [
  'shippingCostValue',
  'shippingCompanyId',
  'shippingCompanyName',
  'shippingMethod',
  'estimatedShippingBusinessDays',
  'estimatedShippingDate',
  'quoteId',
  'freightOrigin',
] as const satisfies readonly (keyof OrderConditionDetailsFormValues)[];

type ServerFreightField = (typeof SERVER_FREIGHT_FIELDS)[number];

export type ServerFreightValues = Pick<OrderConditionDetailsFormValues, ServerFreightField>;

export const CLEARED_FREIGHT_VALUES = {
  shippingCostValue: null,
  shippingCompanyId: null,
  shippingCompanyName: null,
  shippingCompanyExternalId: null,
  shippingMethod: null,
  estimatedShippingBusinessDays: null,
  estimatedShippingDate: null,
  quoteId: null,
} as const satisfies Partial<OrderConditionDetailsFormValues>;

export const getComparableValue = (value: unknown) =>
  value instanceof Date ? value.getTime() : value;

const differs = (value: unknown, other: unknown) =>
  getComparableValue(value) !== getComparableValue(other);

interface ShouldSyncFreightFromServerParams {
  serverFreight: ServerFreightValues;
  savedValues: OrderConditionDetailsFormValues;
  formValues: OrderConditionDetailsFormValues;
}

export const shouldSyncFreightFromServer = ({
  serverFreight,
  savedValues,
  formValues,
}: ShouldSyncFreightFromServerParams) => {
  const hasChangedOnServer = SERVER_FREIGHT_FIELDS.some((field) =>
    differs(serverFreight[field], savedValues[field]),
  );
  const hasUnsavedFreight = SERVER_FREIGHT_FIELDS.some((field) =>
    differs(formValues[field], savedValues[field]),
  );

  return hasChangedOnServer && !hasUnsavedFreight;
};
